var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#888",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.1118 2.51829e-08 14.1694 0.66855 15.8779 1.90983C17.5863 3.15111 18.858 4.9014 19.5106 6.90983C20.1631 8.91826 20.1631 11.0817 19.5106 13.0902C18.858 15.0986 17.5863 16.8489 15.8779 18.0902C14.1694 19.3315 12.1118 20 10 20C7.88821 20 5.83062 19.3314 4.12215 18.0902C2.41367 16.8489 1.14201 15.0986 0.489434 13.0902C-0.163145 11.0817 -0.163145 8.91826 0.489435 6.90983L3.3426 7.83688C2.8858 9.24278 2.8858 10.7572 3.3426 12.1631C3.79941 13.569 4.68957 14.7942 5.8855 15.6631C7.08144 16.532 8.52174 17 10 17C11.4783 17 12.9186 16.532 14.1145 15.6631C15.3104 14.7942 16.2006 13.569 16.6574 12.1631C17.1142 10.7572 17.1142 9.24279 16.6574 7.83688C16.2006 6.43098 15.3104 5.20578 14.1145 4.33688C12.9186 3.46798 11.4783 3 10 3V0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.8af764e00c1c3911d1cc58f4baf65fa0.svg";
export { ForwardRef as ReactComponent };